import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, onMounted} from 'vue';
import useCostCenterState from '@/app/cost-center/infrastructure/persistence/CostCenterState';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCostCenter',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const state = useCostCenterState();



const costCenterOptions = ref<any[]>([]);

onMounted(async () => {
    costCenterOptions.value = await state.getAllSimple();
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    "model-value": __props.modelValue,
    label: "Centro de custo",
    "item-title": "name",
    "item-value": "id",
    items: costCenterOptions.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
  }, null, 8, ["model-value", "items"]))
}
}

})